import { getSubdomain, isCanonicalHost, isCatchAllSubdomain } from './subdomain';

export function getRequestProjectKeyOrFallback(headers: Headers) {
  if (process.env.RMT_PROJECT_KEY) {
    return process.env.RMT_PROJECT_KEY;
  }

  return getRequestProjectKey(headers);
}

export function getRequestProjectKey(headers: Headers) {
  const projectKey = getProjectKeyFromHeaders(headers);
  if (projectKey) {
    return projectKey;
  }

  let host;
  if (headers.has('x-forwarded-host')) {
    host = headers.get('x-forwarded-host');
  }

  if (host) {
    const subdomain = getSubdomain(host);
    if (isCanonicalHost(host) && subdomain && !isCatchAllSubdomain(subdomain)) {
      return subdomain;
    }
  }

  return undefined;
}

export function getProjectKeyFromHeaders(headers: Headers) {
  return headers.get('x-project-key') || '';
}
